import * as React from 'react';
import { Grid, SwipeableDrawer } from '@mui/material';

interface Props {
  id?: string;
  type?: 'top'|'bottom';
  open: boolean;
  swipeToOpen?: boolean;
  maxHeight?: number;
  onClose?: () => void;
  children: React.ReactNode;
}

export const SwipeDrawer: React.FunctionComponent<Props> = (props) => {
  const [open, setOpen] = React.useState(props.open);
  
  const onClose = () => { 
    setOpen(false);
    props.onClose?.();
  }

  const onOpen = () => {    
  }
  
  const  puller = () => {
    return <Grid alignSelf='center' height={5} width={50} bgcolor='silver' borderRadius={50} m={2}/>
  }

  React.useEffect(() => {
    setOpen(props.open);
  }, [props])

  return (
    <SwipeableDrawer
      id={props.id}
      PaperProps={{
        sx: {
          borderTopLeftRadius: props.type==='bottom'? 20 : 0,
          borderTopRightRadius: props.type==='bottom'? 20 : 0,
          borderBottomLeftRadius: props.type==='top'? 20 : 0,
          borderBottomRightRadius: props.type==='top'? 20 : 0
        }
      }}
      anchor={props.type}
      open={open}
      disableSwipeToOpen={!props.swipeToOpen}
      onOpen={onOpen}
      onClose={onClose}
    >
      {props.type==='bottom'? puller() : ''}
      <Grid maxHeight={props.maxHeight || 500} overflow='auto' ml={1} mr={1}> {props.children} </Grid>
      {props.type==='top'? puller():''}
    </SwipeableDrawer>
      
  )
}



